import SelectMulti from "../elements/SelectMulti";
import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { explodeStrToRows, getFlagByAddress, checkPermission, subtractDays } from "../../functions/functions";
import attachments from "../../images/attachment.png"
import Modal from "../elements/Modal";
import Pagination from "../elements/Pagination";
import {setError} from "../../slices/error/ErrorSlice";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from 'react-router-dom';
import withAccess from "../hoc/withAccess";
import {setDined} from "../../slices/error/AccessSlice";
import {ColorRing} from "react-loader-spinner";

const View = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const permissions = useSelector((state) => state.user.permissions);

    const productGroups = [
        {value: '07 08 09', name: 'Фрукты/Овощи'},
        {value: '06 12 0703101100 1211908500', name: 'Растения'},
        // {value: '0601 0602 0603 0604', name: '06 Группа'}
        // {value: '07', name: 'Овощи'},
        // {value: '08', name: 'Фрукты'},
        // {value: '09', name: 'Коренья'},
        // {value: '06', name: 'Цветы'},
        // {value: '12', name: 'Семена'},
        // {value: '0703101100', name: 'Лук севок'},
        // {value: '1211908500', name: 'Мелисса'},
    ];

    const [countriesList, setCountriesList] = useState([]);
    const [markingsList, setMarkingsList] = useState([]);
    const [postavkaList, setPostavkaList] = useState([]);
    const [modal, setModal] = useState({
        show: false,
        text: '',
        handler: () => {}
    })

    const initialSearchForm = {
        number: '',
        deleted: false,
        canceled: false,
        recovery: false,
        date_from: subtractDays(new Date(), -7).toISOString().substring(0,10),
        date_to: new Date().toISOString().substring(0,10),
        productGroup: [],
        countries: [],
        markings: [],
        client: '',
        transp_num: '',
        exporter: '',
        importer: '',
        // hologram: '',
        fss_num: '',
        dest_place_rf: false,
        dest_place_rb: false
    };

    const [searchForm, setSearchForm] = useState(initialSearchForm);

    const[pagination, setPagination] = useState({
        currentPage: 1,
        pagesCount: 0
    });
    const [totalItems, setTotalItems] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getPostavkaList(pagination.currentPage);
        window.scrollTo(0, 0);
    }, [pagination.currentPage]);

    useEffect(() => {
        axios.get('/api/multi-select/country')
            .then(res => {
                setCountriesList(res.data);
            })
        axios.get('/api/multi-select/markings')
            .then(res => {
                setMarkingsList(res.data);
            })

        getPostavkaList();
    }, [])

    function getPostavkaList(page= 1) {
        setLoader(true);

        axios.post('/api/postavka/list', {...searchForm, page: page})
            .then(res => {
                setPostavkaList(res.data);

                let headers = {
                    currentPage:    Number(res.headers['x-pagination-current-page']),
                    pagesCount:     Number(res.headers['x-pagination-pages-count'])
                }
                setPagination(headers);
                setTotalItems(res.headers['x-pagination-total-count']);

                setLoader(false);
            })
            .catch(e => {
                console.log(e)
                if (e.status === 403) {
                    dispatch(setDined(true));
                } else {
                    if (e.response) dispatch(setError(e.response.data));
                }
            })
    }

    function handlerSearch() {
        getPostavkaList();
    }

    function handlerEnterSearch(e) {
        if(e.key === 'Enter'){
            getPostavkaList();
        }
    }

    function resetSearchForm() {
        setSearchForm(initialSearchForm);

        axios.post('/api/postavka/list', {...initialSearchForm, page: 1})
            .then(res => {
                setPostavkaList(res.data);

                let headers = {
                    currentPage:    Number(res.headers['x-pagination-current-page']),
                    pagesCount:     Number(res.headers['x-pagination-pages-count'])
                }
                setPagination(headers);
                setTotalItems(res.headers['x-pagination-total-count']);

                setLoader(false);
            })
            .catch(e => {
                if (e.status === 403) {
                    dispatch(setDined(true));
                } else dispatch(setError(e.response.data));
            })
    }

    const excelReportHandler = async () => {
        setLoader(true);

        await axios.post('/api/report/xls/view', searchForm, {
            responseType: "blob",
        })
            .then(result => {
                console.log(result)
                if (result.status === 200) {
                    let contentDisposition = result.headers['content-disposition'];
                    let findFileArr = /".*"/.exec(contentDisposition);
                    let fileName = findFileArr[0].substring(1, findFileArr[0].length-1);

                    const element = document.createElement("a")
                    const blob = new Blob([result?.data])
                    element.href = URL.createObjectURL(blob)
                    element.download = fileName;
                    document.body.appendChild(element)
                    element.click()

                    element.parentNode.removeChild(element);

                    setLoader(false);
                } else {
                    console.log('error: ' + result )
                }
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })

    }

    function changeSearchFormHandler(e) {
        let name = e.target.name;

        if (name === 'productGroup' || name === 'countries' || name === 'markings') {
            let newArr = [...searchForm[name]];
            newArr.push(e.target.value);

            setSearchForm({...searchForm, [name]: newArr})
        } else if(e.target.type === 'checkbox') {
            setSearchForm({...searchForm, [name]: e.target.checked})
        } else {
            setSearchForm({...searchForm, [name]: e.target.value});
        }
    }

    function delProductGroups(e) {
        let delVal = e.target.getAttribute('ival');
        let newProductGroup = searchForm.productGroup.filter(item => item !== delVal);

        setSearchForm({...searchForm, productGroup: newProductGroup});
    }

    function delCountries(e) {
        let delVal = Number(e.target.getAttribute('ival'));
        let newCountries = searchForm.countries.filter(item => item !== delVal);

        setSearchForm({...searchForm, countries: newCountries});
    }

    function delMarkings(e) {
        let delVal = Number(e.target.getAttribute('ival'));
        let newMarkings = searchForm.markings.filter(item => item !== delVal);

        setSearchForm({...searchForm, markings: newMarkings});
    }

    function closeModalHandler() {
        setModal({...modal, show: ! modal.show});
    }

    function resolveAction(e) {
        let typeAct = e.target.innerHTML;

        if (typeAct === 'Аннулировать') {
            annullateHandler(e);
        } else if (typeAct === 'Удалить') {
            deleteHandler(e);
        } else if (typeAct === 'Восстановить') {
            recoverHandler(e);
        } else if (typeAct === 'Копия') {
            copyHandler(e);
        } else if (typeAct === 'Снять метку') {
            removeMarked(e);
        }
    }

    function annullateHandler(e) {
        let postavkaId = e.target.parentNode.parentNode.getAttribute('iid');
        let postavkaNum = e.target.parentNode.parentNode.getAttribute('inum');

        setModal({
            show: true,
            text: `Вы действительно хотите аннулировать поставку № ${postavkaNum}`,
            handler: () => {
                axios.patch('/api/postavka/set-canceled', {id: postavkaId})
                    .then(res => {
                        getPostavkaList(pagination.currentPage);
                    })
                setModal({...modal, show: false});
            }
        })
    }

    function deleteHandler(e) {
        let postavkaId = e.target.parentNode.parentNode.getAttribute('iid');
        let postavkaNum = e.target.parentNode.parentNode.getAttribute('inum');

        setModal({
            show: true,
            text: `Вы действительно хотите удалить поставку № ${postavkaNum}`,
            handler: () => {
                axios.patch('/api/postavka/set-deleted', {id: postavkaId})
                    .then(res => {
                        getPostavkaList(pagination.currentPage);
                    })
                setModal({...modal, show: false});
            }
        })
    }

    function recoverHandler(e) {
        let postavkaId = e.target.parentNode.parentNode.getAttribute('iid');
        let postavkaNum = e.target.parentNode.parentNode.getAttribute('inum');

        setModal({
            show: true,
            text: `Вы действительно хотите восстановить поставку № ${postavkaNum}`,
            handler: () => {
                axios.patch('/api/postavka/set-deleted', {id: postavkaId, del_bool: false})
                    .then(res => {
                        getPostavkaList(pagination.currentPage);
                    })
                setModal({...modal, show: false});
            }
        })
    }

    function copyHandler(e) {
        let postavkaId = e.target.parentNode.parentNode.getAttribute('iid');
        let postavkaNum = e.target.parentNode.parentNode.getAttribute('inum');

        setModal({
            show: true,
            text: `Выполнить копирование поставки № ${postavkaNum}`,
            handler: () => {
                axios.get(`/api/postavka/${postavkaId}/copy`)
                    .then(res => {
                        // getPostavkaList();
                        let newId = res.data;
                        navigate(`/view/${newId}`);
                    })
                setModal({...modal, show: false});
            }
        })
    }

    function removeMarked(e) {
        let postavkaId = e.target.parentNode.parentNode.getAttribute('iid');
        let postavkaNum = e.target.parentNode.parentNode.getAttribute('inum');

        setModal({
            show: true,
            text: `Вы действительно хотите снять метку с поставки № ${postavkaNum}`,
            handler: () => {
                axios.patch('/api/postavka/remove-marked', {id: postavkaId})
                    .then(res => {
                        getPostavkaList(pagination.currentPage);
                    })
                setModal({...modal, show: false});
            }
        })
    }

    function setCurrentPage(page) {
        setPagination({...pagination, currentPage: page});
    }

    const getFileHandler = async e => {
        let fileId = e.target.getAttribute('fileid');
        await axios.get(`/api/file/download/${fileId}`, {
            responseType: "blob",
        })
            .then(result => {
                console.log(result)
                if (result.status === 200) {
                    let contentDisposition = result.headers['content-disposition'];
                    let findFileArr = /".*"/.exec(contentDisposition);
                    let fileName = findFileArr[0].substring(1, findFileArr[0].length-1);

                    const element = document.createElement("a")
                    const blob = new Blob([result?.data])
                    element.href = URL.createObjectURL(blob)
                    element.download = fileName;
                    document.body.appendChild(element)
                    element.click()

                    element.parentNode.removeChild(element);
                } else {
                    console.log('error: ' + result )
                }
            })
        .catch(e => {
            dispatch(setError(e.response.data));
        })
    }

    let postavkaRow = postavkaList.map((item, index) => {
        let classTrByType = '';
        if (item.type === 'food') classTrByType = 'food_row';
        if (item.type === 'plant') classTrByType = 'plant_row';
        if (item.color_marking) classTrByType = item.color_marking;
        if (item.client == 0) classTrByType = ' table-secondary';

        return <tr key={index} className={classTrByType}>
                <td>
                    <div>{pagination.currentPage * 50 - 50 + (index + 1)}</div>
                    { item.recovery_at &&
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                 className="bi bi-arrow-clockwise red" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                <path
                                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                            </svg>
                        </div>
                    }
                </td>
            {
                checkPermission(permissions, 'l_vvod') &&
                <td><Link to={"/view/" + item.id}>{item.postavka_num}</Link></td>
            }
            <td>{item.date_postavka}</td>
            {
                (
                    checkPermission(permissions, 'l_vvod') ||
                        checkPermission(permissions, 'l_admin') ||
                        checkPermission(permissions, 'klicntrl')
                    ) &&
                    <td>{item.client}</td>
                }
                <td>{item.transp_num}</td>
                <td>{explodeStrToRows(item.exporter, ',')}</td>
                <td>{explodeStrToRows(item.importer, ',')}</td>
                <td>{getFlagByAddress(item.importer_address ? item.importer_address.toLowerCase() : '')}</td>
                <td className='no-line-brake w-auto'>{item.fss}</td>
                <td className='view-cargos'>{
                    item.cargos.map((item, index) =>
                        <div key={index}>{item.production + ' ' + item.netto + ' ' + item.unit}</div>
                    )
                }</td>
                <td>{
                    item.files.map((item, index) =>
                        <div key={item.id}>
                            <span className='link hover' fileid={item.id} onClick={getFileHandler}>{item.source_name}</span>
                        </div>
                    )
                }</td>
                <td>
                    <table className='table-small table-bordered'>
                        <thead>
                        <tr>
                            <th>Номер</th>
                            <th>Дата</th>
                            <th>Страна</th>
                            <th>Файл</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            item.fss_ino.map(item =>
                                <tr key={item.id}>
                                    <td>{item.num}</td>
                                    <td>{item.date}</td>
                                    <td>{item.alpha2}</td>
                                    <td>
                                        <span className='link hover' fileid={item.file_id}
                                              onClick={getFileHandler}>{item.source_file}</span>
                                        </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </td>
                {
                    checkPermission(permissions, 'l_vvod') &&
                    <td>{explodeStrToRows(item.date_create, ' ')}</td>
                }
                <td>{item.preinfo_num}</td>
                <td>{item.preinfo_state}</td>
                {
                    checkPermission(permissions, 'l_vvod') &&
                    <td className='view-actions' iid={item.id} inum={item.postavka_num}>
                    <div><span onClick={resolveAction}>Копия</span></div>
                        <div><Link to={`/view/${item.id}`}>Редактировать</Link></div>
                    <div>{item.deleted ?
                        <span onClick={resolveAction}>Восстановить</span> :
                        <span onClick={resolveAction}>Удалить</span>}
                    </div>
                    {
                        item.client != 0 &&
                        <div><span onClick={resolveAction}>Аннулировать</span></div>
                    }
                    {
                        item.color_marking &&
                        <div><span onClick={resolveAction}>Снять метку</span></div>
                    }
                </td>
                }
            </tr>
        }
    )

    return (
        <>
            <Modal
                header='Подтвердите действие'
                show={modal.show}
                closeHandler={closeModalHandler}
            >
                <div className="float-none">{modal.text}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end mt-2'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={modal.handler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Просмотр</h1>

            <iframe name="hack" className='display-none' src="about:blank"></iframe>

            <form className='view-filter' target='hack' action="about:blank">
                <div className='card bg-light shadow-sm p-2 pt-3 m-2' onKeyPress={handlerEnterSearch}>
                    <div className="row">
                        <div className="col-6 col-md-3 col-lg-3 col-xxl-auto col-max-400">
                            <div className="textOnInput">
                                <label htmlFor="number">Номер поставки</label>
                                <input className="form-control col-max-400" type="text" id="number" name="number" value={searchForm.number}
                                       autoComplete={'off'} onChange={changeSearchFormHandler}/>
                            </div>
                            <div className='d-inline-flex mt-3'>
                                <div className="textOnInput">
                                    <label htmlFor="fss_num">№ ФСС</label>
                                    <input className="form-control" type="text" id="fss_num" name="fss_num"
                                           value={searchForm.fss_num} onChange={changeSearchFormHandler}/>
                                </div>
                                <div className="textOnInput ms-1">
                                    <label htmlFor="transp_num">Номер а/м</label>
                                    <input className="form-control" type="text" id="transp_num" name="transp_num" autoComplete={'off'}
                                           value={searchForm.transp_num} onChange={changeSearchFormHandler}/>
                                </div>
                            </div>
                            {/*<div className='d-block text-start'>*/}
                            {/*    <div className="d-inline-flex ms-1">*/}
                            {/*        <label htmlFor="canceled" className="mb-0 me-1">Аннулированные</label>*/}
                            {/*        <input type="checkbox" className="form-check-input" id="canceled" name="canceled"*/}
                            {/*               onChange={changeSearchFormHandler}*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                        <div className="col-auto mt-0">
                            <div className="textOnInput">
                                <label htmlFor="date_from">Дата с</label>
                                <input className="form-control min-width-200" type="date" id="date_from"
                                       name="date_from" value={searchForm.date_from} onChange={changeSearchFormHandler}
                                />
                            </div>
                            <div className="textOnInput mt-3 ms-1 ms-sm-0">
                                <label htmlFor="date_to">Дата по</label>
                                <input className="form-control min-width-150" type="date" id="date_to" name="date_to"
                                    value={searchForm.date_to} onChange={changeSearchFormHandler}
                                />
                            </div>
                        </div>

                        <div className="col-auto mt-lg-0 mt-sm-3 mt-md-0 mt-3">
                            <SelectMulti
                                data={productGroups}
                                label='Код товара'
                                name='productGroup'
                                id='productGroup'
                                class='col-max-300'
                                handler={changeSearchFormHandler}
                                chosen={searchForm.productGroup}
                                delHandler={delProductGroups}
                            />

                            <SelectMulti
                                data={countriesList}
                                label='Страны'
                                name='countries'
                                id='countries'
                                class='mt-3 col-max-300'
                                handler={changeSearchFormHandler}
                                chosen={searchForm.countries}
                                delHandler={delCountries}
                            />
                        </div>

                        <div className="col-auto col-lg-4 col-xxl-auto mt-3 mt-md-3 mt-lg-3  mt-xl-0">
                            <div className="textOnInput">
                                <label htmlFor="client">Заказчик</label>
                                <input className="form-control col-max-300" type="text" id="client" name="client"
                                       onChange={changeSearchFormHandler} value={searchForm.client}
                                />
                            </div>
                            <SelectMulti
                                data={markingsList}
                                label='Метка'
                                name='markings'
                                class='mt-3 col-max-300'
                                id='markings'
                                handler={changeSearchFormHandler}
                                chosen={searchForm.markings}
                                delHandler={delMarkings}
                            />
                        </div>

                        <div className="col-5 col-sm-5 col-md-3 col-lg-4 col-xxl-auto mt-3 mt-md-3 mt-lg-3 mt-xxl-0">
                            <div className="textOnInput">
                                <label htmlFor="exporter">Отправитель</label>
                                <input className="form-control" type="text" id="exporter" name="exporter"
                                       onChange={changeSearchFormHandler} value={searchForm.exporter}/>
                            </div>
                            <div className="textOnInput mt-3">
                                <label htmlFor="importer">Получатель</label>
                                <input className="form-control" type="text" id="importer" name="importer"
                                       onChange={changeSearchFormHandler} value={searchForm.importer}/>
                            </div>
                        </div>

                        <div className='col-6 col-md-3 col-lg-3 col-xl-auto  col-xxl-auto mt-2 mt-sm-2 mt-xxl-0'>
                                <div className="d-inline-block ms-1 mt-0">
                                    <div><label htmlFor="deleted" className="mb-0 me-1">Удал.</label></div>
                                    <input type="checkbox" className="form-check-input" id="deleted" name='deleted'
                                           onChange={changeSearchFormHandler} checked={searchForm.deleted}
                                    />
                                </div>
                                <div className="d-inline-block ms-1 mt-0">
                                    <div><label htmlFor="recovery" className="mb-0 me-1">Востновл.</label></div>
                                    <input type="checkbox" className="form-check-input" id="recovery" name='recovery'
                                           onChange={changeSearchFormHandler} checked={searchForm.recovery}
                                />
                            </div>
                                <div className='d-block'>
                                    <div className=''>Место дост:</div>
                                    <div className='d-inline-flex'>
                                        <div className="d-inline-flex ms-1 text-start">
                                            <label htmlFor="dest-place-rf" className="mb-0 me-1">РФ</label>
                                            <input type="checkbox" className="form-check-input" id="dest-place-rf"
                                                   name='dest_place_rf' onChange={changeSearchFormHandler} checked={searchForm.dest_place_rf}/>
                                        </div>
                                        <div className="d-inline-flex ms-1">
                                            <label htmlFor="dest-place-rb" className="mb-0 me-1">РБ</label>
                                            <input type="checkbox" className="form-check-input" id="dest-place-rb"
                                                   name='dest_place_rb' onChange={changeSearchFormHandler} checked={searchForm.dest_place_rb}/>
                                        </div>
                                    </div>
                                </div>
                        </div>

                        <div className='col-6 col-md-3 col-lg-3 col-xl-auto col-xxl-auto mt-2 mt-sm-2 mt-xxl-0'>
                            <input type='button' className='d-xxl-block btn mb-0 btn-light me-1' value='Сброс' onClick={resetSearchForm}/>
                            <button type='submit' className='d-xxl-block btn mb-0 btn-success' onClick={handlerSearch}>Поиск</button>
                        </div>
                    </div>
                </div>
            </form>

            <div className=''>
                <span className='float-start ms-3 postavka-amount'>Всего заявок: {totalItems}</span>
                <span className='upload_button' onClick={handlerSearch}>обновить</span>
                {
                    checkPermission(permissions, 'l_admin') &&
                    <span className='float-end me-2 upload_button' onClick={excelReportHandler}>Выгрузка результата в excel
                        <span className='ms-1'>
                            <svg
                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                className="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                                <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/><path
                                d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                            </svg>
                        </span>
                    </span>
                }
            </div>

            <ColorRing
                visible={loader}
                height="80"
                width="80"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            />


            <table className="table table-bordered view m-2">
                <thead>
                <tr className='table-th'>
                    <th>#</th>
                    {
                        checkPermission(permissions, 'l_vvod') &&
                        <th>Поставка №</th>
                    }
                    <th>Дата</th>
                    {
                        (
                            checkPermission(permissions, 'l_vvod') ||
                            checkPermission(permissions, 'l_admin') ||
                            checkPermission(permissions, 'klicntrl')
                        ) &&
                        <th>Заказчик</th>
                    }
                    <th>Автомобиль</th>
                    <th>Отправитель</th>
                    <th>Получатель</th>
                    <th></th>
                    <th>№ ФСС</th>
                    {/*<th>Номер акта пред.<br/>фитосанитарного контроля (MAA)</th>*/}
                    {/*<th>Номер<br/>голограммы</th>*/}
                    <th>Вид товара</th>
                    <th><img src={attachments} height={25}/></th>
                    <th>ФСС страны<br/>происхождения</th>
                    {
                        checkPermission(permissions, 'l_vvod') &&
                        <th>Дата,время<br/>ввода заявки</th>
                    }
                    <th>№ ПИ</th>
                    <th>Статус ПИ</th>
                    {
                        checkPermission(permissions, 'l_vvod') &&
                        <th></th>
                    }
                    </tr>
                </thead>
                <tbody>
                    {postavkaRow}
                </tbody>
            </table>

            <Pagination pagesCount={pagination.pagesCount} currentPage={pagination.currentPage}
                        setPageHandler={setCurrentPage}/>

        </>
    )
}

const ViewWithAccess = withAccess(View);
export default ViewWithAccess;